<!-- <div class="card card-redlaboral m-4">
    <div class="card-body">
        <div class="row">
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h4 class="mt-4 mb-0 text-primary">
                    <i class="fa-solid fa-house"></i>
                    Inicio
                </h4>
                <div class="row">
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="mt-1">
                            <a href="javascript:void(0);" class="text-decoration-none mx-1" (click)="showFilter()">
                                <i class="fa-solid fa-filter"></i>
                                Más filtros
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="card card-dashboard">
                    <div class="card-body py-2 position-relative">
                        <h2 class="mt-0 mb-0">
                            10,480
                        </h2>
                        <h5 class="mt-0 mb-0">
                            Usuarios
                        </h5>
                        <i class="fa-solid fa-users fa-icon-dashboard"></i>
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="card card-dashboard">
                    <div class="card-body py-2 position-relative">
                        <h2 class="mt-0 mb-0">
                            15,610
                        </h2>
                        <h5 class="mt-0 mb-0">
                            Oferta laborales
                        </h5>
                        <i class="fa-solid fa-briefcase fa-icon-dashboard"></i>
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="card card-dashboard">
                    <div class="card-body py-2 position-relative">
                        <h2 class="mt-0 mb-0">
                            540,400
                        </h2>
                        <h5 class="mt-0 mb-0">
                            Candidatos
                        </h5>
                        <i class="fa-solid fa-person fa-icon-dashboard"></i>
                    </div>
                </div>
            </div>
        </div>
        @if (showFilters)
        {
            <div class="card mb-2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>País</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">País A</option>
                                        <option value="2">País B</option>
                                        <option value="3">País C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Provincia</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Provincia A</option>
                                        <option value="2">Provincia B</option>
                                        <option value="3">Provincia C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Municipio</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Municipio A</option>
                                        <option value="2">Municipio B</option>
                                        <option value="3">Municipio C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Ciudad</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Ciudad A</option>
                                        <option value="2">Ciudad B</option>
                                        <option value="3">Ciudad C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Tipo de contrato</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Tiempo completo</option>
                                        <option value="2">Medio tiempo</option>
                                        <option value="3">Freelance</option>
                                        <option value="4">Temporal</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Empresa</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Empresa A</option>
                                        <option value="2">Empresa B</option>
                                        <option value="3">Empresa C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Profesión</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Profesión A</option>
                                        <option value="2">Profesión B</option>
                                        <option value="3">Profesión C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Rango de edad</label>
                                <div class="input-group">
                                    <input type="number" min="0" step="1" class="form-control" placeholder="Min" />
                                    <input type="number" min="0" step="1" class="form-control" placeholder="Max" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="mt-button">
                                <button type="button" class="btn btn-primary">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        <hr class="mt-3 mb-3" />
    </div>
</div> -->
<app-main-statistics></app-main-statistics>